export default "__VITE_ASSET__cc3b5ac2__"